import React from "react"
import { useController, useFormContext } from "react-hook-form"

import type { RadioOption } from "~components/shared/todo-lib-react-components/inputs/radio"
import Radio from "~components/shared/todo-lib-react-components/inputs/radio"

import HookFormControl from "../core/hook-form-control"

interface Props {
    readonly name: string
    readonly label?: string
    readonly isRequired?: boolean
    readonly options: RadioOption[]
    readonly isVertical?: boolean
}

export default function RadioControl({
    name,
    label,
    options,
    isRequired,
    isVertical = true,
}: Props) {
    const { control } = useFormContext()
    const { field } = useController({ name, control })
    const { name: fieldName, onChange, value, disabled } = field

    return (
        <HookFormControl name={name} label={label} isRequired={isRequired}>
            <Radio
                name={fieldName}
                value={value}
                onChange={onChange}
                options={options}
                isDisabled={disabled}
                isVertical={isVertical}
            />
        </HookFormControl>
    )
}
